import { Button } from "@/src/components/atom/Button";
import { ReactComponent as ClockSvg } from "@/src/assets/icons/icon-clock-gray5.svg";
import { ReactComponent as ArrowDownSvg } from "@/src/assets/icons/icon-chevron-down-gray7.svg";
import { ReactComponent as MailSvg } from "@/src/assets/icons/icon-mail-blue.svg";

import DropDown from "@/src/components/atom/DropDown";
import SectionCardWithoutHeader from "@/src/components/molecule/SectionCardWithoutHeader";
import Typo from "@/src/components/atom/Typo";
import colorSet, { ColorType } from "@/src/styles/color";
import { styled } from "styled-components";
import {
  DropdownMenuGroup,
  DropdownMenuItem,
} from "@radix-ui/react-dropdown-menu";

interface EmailDropdownProps {
  disabled?: boolean;
  onEmailClick: () => void;
  onHistoryClick: () => void;
  buttonText: string;
  sendEmailText: string;
  sentHistoryText: string;
}

/**
 * 이메일 드롭다운 컴포넌트
 * 이메일 보내기와 히스토리 보기 기능을 제공하는 드롭다운 메뉴
 */
const EmailDropdown = ({
  disabled,
  onEmailClick,
  onHistoryClick,
  buttonText,
  sendEmailText,
  sentHistoryText,
}: EmailDropdownProps) => {
  return (
    <DropDown
      dropdownContentProps={{ align: "end" }}
      dropdownTriggerProps={{ disabled }}
      dropdownTrigger={
        <StyledButton
          buttonSize={32}
          buttonColor="blue"
          buttonGrade="secondary"
          disabled={disabled}
        >
          <StyledMailIcon size={16} color="indigo" data-disabled={disabled} />
          {buttonText}
          <StyledArrowDownIcon data-disabled={disabled} />
        </StyledButton>
      }
    >
      <StyledSectionCardWithoutHeader>
        <EmailDropDownList>
          <EmailDropDownItem onSelect={onEmailClick}>
            <StyledMailIcon size={18} color="gray2" />
            <Typo>{sendEmailText}</Typo>
          </EmailDropDownItem>

          <EmailDropDownItem onSelect={onHistoryClick}>
            <StyledClockIcon />
            <Typo>{sentHistoryText}</Typo>
          </EmailDropDownItem>
        </EmailDropDownList>
      </StyledSectionCardWithoutHeader>
    </DropDown>
  );
};

export default EmailDropdown;

const EmailDropDownList = styled(DropdownMenuGroup)`
  display: flex;
  flex-direction: column;
`;

const EmailDropDownItem = styled(DropdownMenuItem)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
  outline: none;

  &:focus,
  &:hover {
    background: ${colorSet.gray10};
  }
`;

const StyledArrowDownIcon = styled(ArrowDownSvg)`
  &[data-disabled="true"] {
    path {
      fill: ${colorSet.gray8};
    }
  }
`;

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 32px;
`;

const StyledSectionCardWithoutHeader = styled(SectionCardWithoutHeader)`
  background: ${colorSet.white};
`;

const StyledClockIcon = styled(ClockSvg)`
  width: 18px;
  height: 18px;

  path {
    fill: ${colorSet.gray2};
  }
`;

const StyledMailIcon = styled(MailSvg)<{ size?: number; color?: ColorType }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  path {
    fill: ${({ color }) => colorSet[color || "indigo"]};
  }

  &[data-disabled="true"] {
    path {
      fill: ${colorSet.gray8};
    }
  }
`;
